// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact {
  max-width: 1400px;
  margin: 0 auto;
  padding: clamp(2rem, 5vw, 4rem) clamp(1rem, 3vw, 2rem);
  /* ---------- TITLE ---------- */
}
.contact__title {
  font-size: clamp(1.4rem, 5vw, 2.2rem);
  font-weight: 800;
  color: #1e2150;
  margin-bottom: clamp(1.5rem, 4vw, 2.5rem);
  text-align: center;
  line-height: 1.2;
}
@media (max-width: 768px) {
  .contact__title {
    font-size: clamp(1.3rem, 6vw, 1.9rem);
    margin-bottom: clamp(1.25rem, 3vw, 2rem);
  }
}
@media (max-width: 576px) {
  .contact__title {
    font-size: clamp(1.2rem, 7vw, 1.6rem);
    margin-bottom: clamp(1rem, 3vw, 1.5rem);
  }
}
.contact {
  /* ---------- GRID LAYOUT ---------- */
}
.contact__grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: clamp(1.5rem, 4vw, 2.5rem);
  align-items: start;
}
@media (max-width: 1024px) {
  .contact__grid {
    grid-template-columns: 1fr 0.7fr;
    gap: clamp(1.25rem, 3vw, 2rem);
  }
}
@media (max-width: 768px) {
  .contact__grid {
    grid-template-columns: 1fr;
    gap: clamp(2rem, 5vw, 3rem);
  }
}
@media (max-width: 576px) {
  .contact__grid {
    gap: clamp(1.5rem, 4vw, 2.5rem);
  }
}
.contact {
  /* ---------- FORM SECTION ---------- */
}
.contact__form {
  display: flex;
  flex-direction: column;
  gap: clamp(0.75rem, 2vw, 1rem);
}
.contact__form .input,
.contact__form .textarea {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: clamp(6px, 1vw, 8px);
  padding: clamp(12px, 2.5vw, 14px) clamp(14px, 3vw, 16px);
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  background: #fafafa;
}
.contact__form .input:focus,
.contact__form .textarea:focus {
  border-color: #1e2150;
  box-shadow: 0 0 0 3px rgba(36, 52, 109, 0.15);
  background: #fff;
}
@media (max-width: 576px) {
  .contact__form .input,
  .contact__form .textarea {
    font-size: clamp(0.85rem, 3vw, 0.95rem);
    padding: clamp(10px, 2vw, 12px) clamp(12px, 2.5vw, 14px);
    border-radius: 6px;
  }
}
@media (max-width: 480px) {
  .contact__form .input,
  .contact__form .textarea {
    font-size: 16px;
  }
}
.contact__form .textarea {
  min-height: clamp(120px, 20vw, 150px);
  resize: vertical;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .contact__form .textarea {
    min-height: clamp(100px, 15vw, 120px);
  }
}
@media (max-width: 576px) {
  .contact__form .textarea {
    min-height: clamp(80px, 12vw, 100px);
    resize: none;
  }
}
.contact__form .contact__button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: clamp(0.5rem, 2vw, 1rem);
}
.contact__form .contact__button-wrapper .contact__submit {
  border: 2px solid #1e2150;
  background: transparent;
  color: #1e2150;
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  font-weight: 600;
  padding: clamp(10px, 2vw, 12px) clamp(30px, 6vw, 40px);
  border-radius: 40px;
  cursor: pointer;
  transition: all 0.25s ease;
}
.contact__form .contact__button-wrapper .contact__submit:hover {
  background: #1e2150;
  color: white;
  transform: translateY(-2px);
}
@media (max-width: 576px) {
  .contact__form .contact__button-wrapper .contact__submit {
    width: 100%;
    font-size: clamp(0.85rem, 3vw, 0.95rem);
    padding: clamp(12px, 2.5vw, 14px) 0;
    border-radius: 8px;
    justify-content: center;
  }
}
.contact__form .form-status {
  text-align: center;
  margin-top: clamp(0.6rem, 2vw, 0.8rem);
  font-weight: 600;
  font-size: clamp(0.85rem, 2vw, 0.95rem);
}
.contact__form .form-status.ok {
  color: #18a957;
}
.contact__form .form-status.err {
  color: #d64545;
}
.contact {
  /* ---------- SOCIAL LINKS ---------- */
  /* ---------- SOCIAL ICONS ---------- */
}
.contact .contact__socials .social-icons {
  display: flex;
  gap: clamp(10px, 2vw, 16px);
}
.contact .contact__socials .social-icons a {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1.5px solid rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e2150;
  font-size: 1.2rem;
  transition: all 0.25s ease;
  background: #fff;
}
.contact .contact__socials .social-icons a:hover {
  background: #1e2150;
  color: #fff;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(36, 52, 109, 0.25);
}
@media (max-width: 768px) {
  .contact .contact__socials .social-icons {
    justify-content: center;
  }
}
.contact {
  /* ---------- INFO SECTION ---------- */
}
.contact__info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  padding-left: clamp(1rem, 3vw, 2rem);
  gap: clamp(1rem, 2.5vw, 1.5rem);
}
@media (max-width: 1024px) {
  .contact__info {
    gap: clamp(0.8rem, 2vw, 1.2rem);
    padding-left: clamp(0.75rem, 2vw, 1.5rem);
  }
}
@media (max-width: 768px) {
  .contact__info {
    border-left: none;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding-left: 0;
    padding-top: clamp(1.5rem, 4vw, 2rem);
    align-items: center;
    text-align: center;
    gap: clamp(1.25rem, 3vw, 1.5rem);
  }
}
@media (max-width: 576px) {
  .contact__info {
    gap: clamp(1rem, 2.5vw, 1.25rem);
    padding-top: clamp(1rem, 3vw, 1.5rem);
  }
}
.contact__info .info-item h4 {
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  color: #1e2150;
  margin-bottom: clamp(4px, 1vw, 6px);
  font-weight: 600;
}
@media (max-width: 576px) {
  .contact__info .info-item h4 {
    font-size: clamp(0.85rem, 3vw, 0.95rem);
  }
}
.contact__info .info-item a,
.contact__info .info-item p {
  color: #111827;
  text-decoration: none;
  font-size: clamp(0.85rem, 2.2vw, 1rem);
  line-height: 1.4;
}
@media (max-width: 576px) {
  .contact__info .info-item a,
  .contact__info .info-item p {
    font-size: clamp(0.8rem, 2.5vw, 0.9rem);
  }
}
.contact__info .info-item a:hover {
  color: #1e2150;
  text-decoration: underline;
}
.contact {
  /* ---------- RESPONSIVE PADDING ---------- */
}
@media (max-width: 1200px) {
  .contact {
    padding: clamp(1.5rem, 4vw, 3rem) clamp(1.5rem, 4vw, 2rem);
  }
}
@media (max-width: 768px) {
  .contact {
    padding: clamp(1.25rem, 3vw, 2rem) clamp(1rem, 2.5vw, 1.5rem);
  }
}
@media (max-width: 576px) {
  .contact {
    padding: clamp(1rem, 2.5vw, 1.5rem) clamp(0.75rem, 2vw, 1rem);
  }
}
@media (max-width: 480px) {
  .contact {
    padding: clamp(0.75rem, 2vw, 1rem) clamp(0.5rem, 1.5vw, 0.75rem);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styleHomePage/contact.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,iBCiCU;EDhCV,cAAA;EACA,sDAAA;EAEA,gCAAA;AAFF;AAGE;EACE,qCAAA;EACA,gBAAA;EACA,cCMS;EDLT,yCAAA;EACA,kBAAA;EACA,gBAAA;AADJ;AAGI;EARF;IASI,qCAAA;IACA,wCAAA;EAAJ;AACF;AAEI;EAbF;IAcI,qCAAA;IACA,uCAAA;EACJ;AACF;AAvBA;EAyBE,sCAAA;AACF;AAAE;EACE,aAAA;EACA,kCAAA;EACA,+BAAA;EACA,kBAAA;AAEJ;AAAI;EANF;IAOI,gCAAA;IACA,8BAAA;EAGJ;AACF;AADI;EAXF;IAYI,0BAAA;IACA,2BAAA;EAIJ;AACF;AAFI;EAhBF;IAiBI,+BAAA;EAKJ;AACF;AAjDA;EA+CE,uCAAA;AAKF;AAJE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AAMJ;AAJI;;EAEE,WAAA;EACA,sBAAA;EACA,mCAAA;EACA,wDAAA;EACA,qCAAA;EACA,aAAA;EACA,8CAAA;EACA,mBAAA;AAMN;AAJM;;EACE,qBClDK;EDmDL,6CAAA;EACA,gBAAA;AAOR;AAJM;EAjBF;;IAkBI,uCAAA;IACA,wDAAA;IACA,kBAAA;EAQN;AACF;AANM;EAvBF;;IAwBI,eAAA;EAUN;AACF;AAPI;EACE,qCAAA;EACA,gBAAA;EACA,gBAAA;AASN;AAPM;EALF;IAMI,qCAAA;EAUN;AACF;AARM;EATF;IAUI,oCAAA;IACA,YAAA;EAWN;AACF;AARI;EACE,aAAA;EACA,uBAAA;EACA,oCAAA;AAUN;AARM;EACE,yBAAA;EACA,uBAAA;EACA,cCzFK;ED0FL,qCAAA;EACA,gBAAA;EACA,sDAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AAUR;AARQ;EACE,mBClGG;EDmGH,YAAA;EACA,2BAAA;AAUV;AAPQ;EAjBF;IAkBI,WAAA;IACA,uCAAA;IACA,mCAAA;IACA,kBAAA;IACA,uBAAA;EAUR;AACF;AALI;EACE,kBAAA;EACA,sCAAA;EACA,gBAAA;EACA,uCAAA;AAON;AALM;EACE,cAAA;AAOR;AAJM;EACE,cAAA;AAMR;AAlJA;EAgJE,uCAAA;EACA,uCAAA;AAKF;AAHI;EACE,aAAA;EACA,2BAAA;AAKN;AAHM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,cCjJK;EDkJL,iBAAA;EACA,0BAAA;EACA,gBAAA;AAIR;AAFQ;EACE,mBCvJG;EDwJH,WAAA;EACA,2BAAA;EACA,8CAAA;AAIV;AAAM;EA1BF;IA2BI,uBAAA;EAGN;AACF;AAlLA;EAoLE,uCAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,yCAAA;EACA,oCAAA;EACA,+BAAA;AAEJ;AAAI;EARF;IASI,+BAAA;IACA,yCAAA;EAGJ;AACF;AADI;EAbF;IAcI,iBAAA;IACA,wCAAA;IACA,eAAA;IACA,qCAAA;IACA,mBAAA;IACA,kBAAA;IACA,gCAAA;EAIJ;AACF;AAFI;EAvBF;IAwBI,gCAAA;IACA,qCAAA;EAKJ;AACF;AAFM;EACE,qCAAA;EACA,cCrMK;EDsML,mCAAA;EACA,gBAAA;AAIR;AAFQ;EANF;IAOI,uCAAA;EAKR;AACF;AAFM;;EAEE,cCvMD;EDwMC,qBAAA;EACA,sCAAA;EACA,gBAAA;AAIR;AAFQ;EAPF;;IAQI,uCAAA;EAMR;AACF;AAHM;EACE,cC3NK;ED4NL,0BAAA;AAKR;AAhPA;EAgPE,6CAAA;AAGF;AAFE;EAjPF;IAkPI,0DAAA;EAKF;AACF;AAHE;EArPF;IAsPI,6DAAA;EAMF;AACF;AAJE;EAzPF;IA0PI,6DAAA;EAOF;AACF;AALE;EA7PF;IA8PI,gEAAA;EAQF;AACF","sourcesContent":["@use \"../variables\" as v;\r\n\r\n.contact {\r\n  max-width: v.$max-width;\r\n  margin: 0 auto;\r\n  padding: clamp(2rem, 5vw, 4rem) clamp(1rem, 3vw, 2rem);\r\n\r\n  /* ---------- TITLE ---------- */\r\n  &__title {\r\n    font-size: clamp(1.4rem, 5vw, 2.2rem);\r\n    font-weight: 800;\r\n    color: v.$brand-blue;\r\n    margin-bottom: clamp(1.5rem, 4vw, 2.5rem);\r\n    text-align: center;\r\n    line-height: 1.2;\r\n\r\n    @media (max-width: 768px) {\r\n      font-size: clamp(1.3rem, 6vw, 1.9rem);\r\n      margin-bottom: clamp(1.25rem, 3vw, 2rem);\r\n    }\r\n\r\n    @media (max-width: 576px) {\r\n      font-size: clamp(1.2rem, 7vw, 1.6rem);\r\n      margin-bottom: clamp(1rem, 3vw, 1.5rem);\r\n    }\r\n  }\r\n\r\n  /* ---------- GRID LAYOUT ---------- */\r\n  &__grid {\r\n    display: grid;\r\n    grid-template-columns: 1.2fr 0.8fr;\r\n    gap: clamp(1.5rem, 4vw, 2.5rem);\r\n    align-items: start;\r\n\r\n    @media (max-width: 1024px) {\r\n      grid-template-columns: 1fr 0.7fr;\r\n      gap: clamp(1.25rem, 3vw, 2rem);\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      grid-template-columns: 1fr;\r\n      gap: clamp(2rem, 5vw, 3rem);\r\n    }\r\n\r\n    @media (max-width: 576px) {\r\n      gap: clamp(1.5rem, 4vw, 2.5rem);\r\n    }\r\n  }\r\n\r\n  /* ---------- FORM SECTION ---------- */\r\n  &__form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: clamp(0.75rem, 2vw, 1rem);\r\n\r\n    .input,\r\n    .textarea {\r\n      width: 100%;\r\n      border: 1px solid #ddd;\r\n      border-radius: clamp(6px, 1vw, 8px);\r\n      padding: clamp(12px, 2.5vw, 14px) clamp(14px, 3vw, 16px);\r\n      font-size: clamp(0.9rem, 2.5vw, 1rem);\r\n      outline: none;\r\n      transition: border-color 0.2s, box-shadow 0.2s;\r\n      background: #fafafa;\r\n\r\n      &:focus {\r\n        border-color: v.$brand-blue;\r\n        box-shadow: 0 0 0 3px rgba(36, 52, 109, 0.15);\r\n        background: #fff;\r\n      }\r\n\r\n      @media (max-width: 576px) {\r\n        font-size: clamp(0.85rem, 3vw, 0.95rem);\r\n        padding: clamp(10px, 2vw, 12px) clamp(12px, 2.5vw, 14px);\r\n        border-radius: 6px;\r\n      }\r\n\r\n      @media (max-width: 480px) {\r\n        font-size: 16px;\r\n      }\r\n    }\r\n\r\n    .textarea {\r\n      min-height: clamp(120px, 20vw, 150px);\r\n      resize: vertical;\r\n      line-height: 1.5;\r\n\r\n      @media (max-width: 768px) {\r\n        min-height: clamp(100px, 15vw, 120px);\r\n      }\r\n\r\n      @media (max-width: 576px) {\r\n        min-height: clamp(80px, 12vw, 100px);\r\n        resize: none;\r\n      }\r\n    }\r\n\r\n    .contact__button-wrapper {\r\n      display: flex;\r\n      justify-content: center;\r\n      margin-top: clamp(0.5rem, 2vw, 1rem);\r\n\r\n      .contact__submit {\r\n        border: 2px solid v.$brand-blue;\r\n        background: transparent;\r\n        color: v.$brand-blue;\r\n        font-size: clamp(0.9rem, 2.5vw, 1rem);\r\n        font-weight: 600;\r\n        padding: clamp(10px, 2vw, 12px) clamp(30px, 6vw, 40px);\r\n        border-radius: 40px;\r\n        cursor: pointer;\r\n        transition: all 0.25s ease;\r\n\r\n        &:hover {\r\n          background: v.$brand-blue;\r\n          color: white;\r\n          transform: translateY(-2px);\r\n        }\r\n\r\n        @media (max-width: 576px) {\r\n          width: 100%;\r\n          font-size: clamp(0.85rem, 3vw, 0.95rem);\r\n          padding: clamp(12px, 2.5vw, 14px) 0;\r\n          border-radius: 8px;\r\n          justify-content: center;\r\n\r\n        }\r\n      }\r\n    }\r\n\r\n    .form-status {\r\n      text-align: center;\r\n      margin-top: clamp(0.6rem, 2vw, 0.8rem);\r\n      font-weight: 600;\r\n      font-size: clamp(0.85rem, 2vw, 0.95rem);\r\n\r\n      &.ok {\r\n        color: #18a957;\r\n      }\r\n\r\n      &.err {\r\n        color: #d64545;\r\n      }\r\n    }\r\n  }\r\n  /* ---------- SOCIAL LINKS ---------- */\r\n  /* ---------- SOCIAL ICONS ---------- */\r\n  .contact__socials {\r\n    .social-icons {\r\n      display: flex;\r\n      gap: clamp(10px, 2vw, 16px);\r\n\r\n      a {\r\n        width: 42px;\r\n        height: 42px;\r\n        border-radius: 50%;\r\n        border: 1.5px solid rgba(0, 0, 0, 0.15);\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        color: v.$brand-blue;\r\n        font-size: 1.2rem;\r\n        transition: all 0.25s ease;\r\n        background: #fff;\r\n\r\n        &:hover {\r\n          background: v.$brand-blue;\r\n          color: #fff;\r\n          transform: translateY(-3px);\r\n          box-shadow: 0 8px 20px rgba(36, 52, 109, 0.25);\r\n        }\r\n      }\r\n\r\n      @media (max-width: 768px) {\r\n        justify-content: center;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  /* ---------- INFO SECTION ---------- */\r\n  &__info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    border-left: 1px solid rgba(0, 0, 0, 0.1);\r\n    padding-left: clamp(1rem, 3vw, 2rem);\r\n    gap: clamp(1rem, 2.5vw, 1.5rem);\r\n\r\n    @media (max-width: 1024px) {\r\n      gap: clamp(0.8rem, 2vw, 1.2rem);\r\n      padding-left: clamp(0.75rem, 2vw, 1.5rem);\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      border-left: none;\r\n      border-top: 1px solid rgba(0, 0, 0, 0.1);\r\n      padding-left: 0;\r\n      padding-top: clamp(1.5rem, 4vw, 2rem);\r\n      align-items: center;\r\n      text-align: center;\r\n      gap: clamp(1.25rem, 3vw, 1.5rem);\r\n    }\r\n\r\n    @media (max-width: 576px) {\r\n      gap: clamp(1rem, 2.5vw, 1.25rem);\r\n      padding-top: clamp(1rem, 3vw, 1.5rem);\r\n    }\r\n\r\n    .info-item {\r\n      h4 {\r\n        font-size: clamp(0.9rem, 2.5vw, 1rem);\r\n        color: v.$brand-blue;\r\n        margin-bottom: clamp(4px, 1vw, 6px);\r\n        font-weight: 600;\r\n\r\n        @media (max-width: 576px) {\r\n          font-size: clamp(0.85rem, 3vw, 0.95rem);\r\n        }\r\n      }\r\n\r\n      a,\r\n      p {\r\n        color: v.$dark;\r\n        text-decoration: none;\r\n        font-size: clamp(0.85rem, 2.2vw, 1rem);\r\n        line-height: 1.4;\r\n\r\n        @media (max-width: 576px) {\r\n          font-size: clamp(0.8rem, 2.5vw, 0.9rem);\r\n        }\r\n      }\r\n\r\n      a:hover {\r\n        color: v.$brand-blue;\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n  }\r\n\r\n  /* ---------- RESPONSIVE PADDING ---------- */\r\n  @media (max-width: 1200px) {\r\n    padding: clamp(1.5rem, 4vw, 3rem) clamp(1.5rem, 4vw, 2rem);\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    padding: clamp(1.25rem, 3vw, 2rem) clamp(1rem, 2.5vw, 1.5rem);\r\n  }\r\n\r\n  @media (max-width: 576px) {\r\n    padding: clamp(1rem, 2.5vw, 1.5rem) clamp(0.75rem, 2vw, 1rem);\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    padding: clamp(0.75rem, 2vw, 1rem) clamp(0.5rem, 1.5vw, 0.75rem);\r\n  }\r\n}","// =========================\r\n// Typography\r\n// =========================\r\n$font-base: \"Noto Sans Armenian\",\r\n-apple-system,\r\nBlinkMacSystemFont,\r\n\"Segoe UI\",\r\nRoboto,\r\nOxygen,\r\nUbuntu,\r\nCantarell,\r\n\"Helvetica Neue\",\r\nsans-serif;\r\n\r\n// =========================\r\n// Brand Colors\r\n// =========================\r\n$brand-blue: #1e2150;\r\n$brand-green: #9eba44;\r\n\r\n// Base Colors\r\n$primary: $brand-blue;\r\n$secondary: $brand-green;\r\n$accent: #facc15;\r\n\r\n$light: #ffffff;\r\n$dark: #111827;\r\n$gray: #6b7280;\r\n$text-muted: #555;\r\n\r\n// Backgrounds\r\n$bg-light: #f9fafb;\r\n$bg-alt: #f0f0f5;\r\n$bg-gray: #f6f6f6;\r\n\r\n// Layout\r\n$max-width: 1400px;\r\n$layout-padding-x: 70px;\r\n\r\n// Spacing\r\n$spacing-xs: 0.25rem;\r\n$spacing-sm: 0.5rem;\r\n$spacing-md: 1rem;\r\n$spacing-lg: 2rem;\r\n$spacing-xl: 4rem;\r\n\r\n// Radius\r\n$radius-xs: 4px;\r\n$radius-sm: 8px;\r\n$radius-md: 12px;\r\n$radius-lg: 20px;\r\n$radius-round: 999px;\r\n\r\n// Shadows\r\n$shadow-medium: 0 4px 18px rgba(0, 0, 0, 0.15);\r\n\r\n// Transitions\r\n$transition-fast: 0.2s;\r\n$transition-normal: 0.3s;\r\n$transition-slow: 0.5s;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
